import React, {Component} from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import {Button, Card, Form, notification, Popconfirm, Tabs, Tooltip} from 'antd'
import {TableComp, FormUtils as GetAllFormFields} from 'sz-react-utils'
import Request from '../../../request'
import styles from '../../Template/all/styles.less'
import moment from 'moment'
import _ from 'lodash'

import {RightsWrapper} from '../../../components/_utils/utils'
const TabPane = Tabs.TabPane

@Form.create()

class AllTargets extends Component {
  state = {
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    taxType: '',
    countryArr: []
  }

  apiRequest = params => {
    return new Promise(async resolve => {
      this.setState({exportParams: params})
      let data = await Request.getTargetDetails({
        ...params,
        regExFilters: []
      })
      this.setState({total: data.total})
      resolve(data)
    })
  }
  handleSubmit = e => {
    const {form} = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData)
        let x = null
        if (this.state.id) {
          values._id = this.state.id
          x = await Request.updateTargetDetails(values)
        } else {
          x = await Request.addTargetDetails(values)
        }

        if (!x.error) {
          this.setState({
            id: '',
            activeTab: '0',
          })
          notification.success({
            message: this.state.id
              ? `Target Updated Successfully`
              : 'Target Added successfully'
          })
          if (!this.state.id) {
            form.resetFields()
          }
          if (this.table && this.table.current)
            this.table.current.reload()

        } else {
          notification.error({
            message: 'Error Saving',
            description: x.msg
          })
        }
      }
    })
  }
  deleteTargetDetails = async data => {
    this.setState({loading: true})
    await Request.deleteTargetDetails(data)

    this.setState({loading: false})

    this.table.current.reload()

    notification.success({
      message: 'Deleted Successfully',
      duration: 20,
      key: `${data._id}-close`
    })
  }
  callback = (value) => {
    if (value) {
      this.chooseTab(value)
    }
  }
  setTargetDetailsData(targetId) {
    if (targetId) {
      Request.financeTargetDetailsByID({id: targetId}).then(
        ({doc, error, message}) => {
          if (!error && doc) {
            this.setState({
              id: doc._id,
              activeTab: '1',
            })
            
            this.props.form.setFieldsValue({
              countryId: doc.countryId,
              taxType: doc.taxType,
              taxHST: doc.taxHST,
              taxGST: doc.taxGST,
              taxStatus: doc.taxStatus
            })
          } else {
            notification.error({
              message: 'Error Getting Data',
              description: message
            })
          }
        }
      )
    }
  }
  refreshFxn = () => {
    this.setState({refreshChild: !this.state.refreshChild})
  }

  loadCountry() {
    let params = {
        results: 100,
        sortField: "countryName",
        sortOrder: "ascend",
    };
    Request.getCountriesWithoutAuth(params)
        .then((resp) => {
            if (resp) {
                let temp = [];
                _.each(resp.data, (vv) => {
                    temp.push({
                        display: vv.countryName,
                        id: vv._id,
                    });
                });
                this.setState({countryArr: temp});
            }
        })
        .catch((err) => {
        });
  }

  componentWillMount() {
    this.loadCountry()
  }

  async componentDidMount() {
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }
  chooseTab(value) {
    this.setState({
        activeTab: value
    })
  }
  render() {
    const {
      form: {getFieldDecorator}
    } = this.props
    const {countryArr, id, taxType} = this.state;

    const inputTypes = {
      fields: [
        {
          label: 'Select Country ',
          key: 'countryId',
          required: true,
          type: 'select',
          showSearch: true,
          disabled: false,
          options: countryArr,
          onChange: v => {
            this.props.form.setFieldsValue({
              countryId: v
            })
          }
        },
        {
          label: 'Tax Type',
          key: 'taxType',
          type: 'select',
          required: true,
          showSearch: true,
          disabled: false,
          options: [
            'HST', 'GST'
          ],
          onChange: v => {
            this.setState({taxType: v});
            this.props.form.setFieldsValue({
              taxType: v
            })
          }
        },
        {
          label: 'Tax (HST)',
          key: 'taxHST',
          hidden: (taxType === 'HST' ? false : true),
          required: (taxType === 'HST')
        },
        {
          label: 'Tax (GST)',
          key: 'taxGST',
          hidden: (taxType === 'GST' ? false : true),
          required: (taxType === 'GST')
        },
        {
          label: 'Status',
          key: 'taxStatus',
          type: 'select',
          required: true,
          showSearch: true,
          disabled: false,
          options: [
            'Active', 'Inactive'
          ],
          onChange: v => {
            this.props.form.setFieldsValue({
              taxStatus: v
            })
          }
        }
      ]
    };

    const columns = [
      {
        title: 'Country Name',
        key: 'countryName',
      },
      {
        title: 'Tax Type',
        key: 'taxType',
      },
      {
        title: 'Tax',
        key: 'taxHST',
        render: (text, record) => {
          return (
            <div>
              <div>{record.taxType === 'HST' ? record.taxHST : record.taxGST}</div>
            </div>
          )
        }
      },
      {
        title: 'Updated By',
        key: 'lastUpdatedByName',
        dataIndex: 'lastUpdatedByName',
        render: (text, record) => {
          return (
            <div>
              <div>{record.updatedByUser != null ? record.updatedByUser.name : record.createdByUser != null ? record.createdByUser.name : ""}</div>
              <small>{record.updatedByUser ? moment(record.updatedByUser.time).format('lll') : record.createdByUser ? moment(record.createdByUser.time).format('lll') : '' }</small>
            </div>
          )
        }
      },
      {
        title: 'Action',
        key: 'operation',
        render: (text, record) => (
          <React.Fragment>
            <RightsWrapper myRight={'financeTax.edit'}>
              <Tooltip title="Edit Target">
                <Button
                  className={styles.btn}
                  shape="circle"
                  onClick={() => {
                    this.setTargetDetailsData(record._id)
                  }}
                  icon="edit"
                />
              </Tooltip>
            </RightsWrapper>
            <RightsWrapper myRight={'financeTax.delete'}>
              <Tooltip title="Delete Tax">
                <Popconfirm
                  title="Are you sure delete this Target?"
                  onConfirm={() => {
                    this.deleteTargetDetails({_id: record._id})
                  }}
                  okText="Yes"
                  cancelText="No">
                  <Button
                    className={styles.btn}
                    shape="circle"
                    icon="delete"
                  />
                </Popconfirm>
              </Tooltip>
            </RightsWrapper>
          </React.Fragment>
        )
      }
    ]
    return (
      <PageHeaderWrapper title={` Counseller Targets `}>
        <Card bordered={true}>
          <Tabs onChange={this.callback} type="card" activeKey={this.state.activeTab}>
            <TabPane tab={`All Targets`} key={0}>
              <h2>{`Total : ${this.state.total}`}</h2>
              <TableComp
                ref={this.table}
                columns={columns}
                apiRequest={this.apiRequest}
                extraProps={{scroll: {x: 900}}}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 50,
                  pageSizeOptions: ['10', '20', '50', '100', '1000']
                }}
              />
            </TabPane>
            
            <TabPane tab={(id?'Edit':'Add') + ' Target'} key={1}>
              <Form onSubmit={this.handleSubmit} style={{marginTop: 8}}>
                <GetAllFormFields
                  inputSchema={inputTypes}
                  refresh={this.refreshFxn}
                  getFieldDecorator={getFieldDecorator}
                />
                <Button
                  type=""
                  htmlType="submit"
                  style={{
                    marginBottom: 10,
                    marginLeft: '33%',
                    backgroundColor: 'green',
                    color: 'white'
                  }}
                  loading={this.props.loading}>
                  SAVE
                </Button>
                <Button
                  type="primary"
                  style={{marginBottom: 10, marginLeft: '1%'}}
                  loading={this.props.loading}
                  onClick={() => {
                    this.props.form.resetFields()
                  }}>
                  RESET
                </Button>
              </Form>
            </TabPane>
          </Tabs>
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default AllTargets
